import { useReveal } from "../../../../hooks/useReveal";
import styles from "./HowItWorks.module.css";

const steps = [
  {
    num: 1,
    title: "Define the role",
    body: "Tell us what success looks like — skills, seniority, working style, location.",
  },
  {
    num: 2,
    title: "AI matches talent",
    body: "Our engine ranks pre-vetted candidates against your role in seconds.",
  },
  {
    num: 3,
    title: "Review & shortlist",
    body: "Browse profiles with assessment scores, work samples, and verified references.",
  },
  {
    num: 4,
    title: "Hire & onboard",
    body: "Schedule, offer, and onboard — all from one workspace your team will love.",
  },
];

function StepCard({ num, title, body }) {
  const { ref, isVisible } = useReveal();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${isVisible ? styles.visible : styles.hidden}`}
    >
      <div className={styles.stepNum}>{num}</div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}

export default function HowItWorks() {
  return (
    <section className={styles.section} id="how">
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>How it works</span>
          <h2 className={styles.h2}>Four steps. One great hire.</h2>
          <p className={styles.sub}>
            From job posting to signed offer — most teams hire in under two
            weeks.
          </p>
        </div>

        <div className={styles.grid}>
          <div className={styles.howLine} aria-hidden="true" />
          {steps.map((s) => (
            <StepCard key={s.num} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
